/* angular:styles/component:css;72e7871545ac0d772bfdad2cbd5fec7e99dcc78445be5790652b2113223bdccd;/codebuild/output/src1273960344/src/smartdineuinew/src/app/common/components/menus/menus.component.ts */
ion-icon[slot=start] {
  margin-inline-end: 16px;
}
/*# sourceMappingURL=menus.component.css.map */
